function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M10.854 6.528a4.333 4.333 0 0 1 4.328 4.326 4.333 4.333 0 0 1-4.328 4.328 4.333 4.333 0 0 1-4.326-4.328 4.333 4.333 0 0 1 4.326-4.326m7.933 11.68l-3.45-3.59a5.836 5.836 0 0 0 1.373-3.764A5.86 5.86 0 0 0 10.854 5 5.861 5.861 0 0 0 5 10.854a5.862 5.862 0 0 0 5.854 5.856 5.787 5.787 0 0 0 3.355-1.06l3.478 3.617a.758.758 0 0 0 1.079.021.764.764 0 0 0 .02-1.08" /></svg>;
});


// WEBPACK FOOTER //
// ./src/components/Icon/icons/search.icon.svg